// Define a form component that's used whenever a user is forced to reset
// their password after logging in and before being allowed into the main
// application.
import React from 'react';
import {connect} from 'react-redux';
import {Form, FormRenderProps} from 'react-final-form';
import {Location, NavigateFunction} from 'react-router-dom';

import {Button, Grid} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import {login as loginAction} from 'spectra-logic-ui/actions';
import {TextField} from 'spectra-logic-ui/components';
import {loginStyles} from 'spectra-logic-ui/components/login';
import {Dispatch} from 'spectra-logic-ui';

import {FormValues} from '@/login/reset_password/types';
import {validate} from '@/login/reset_password/validate';

type Props = {
  location?: Location;
  navigate?: NavigateFunction;
  session?: string;
  challengeName?: string;
  challengeParameters?: {
    [name: string]: string;
  };
  onSubmit?: (...args: any) => void;
}

const useStyles = makeStyles(loginStyles);

const ResetPasswordForm = ({onSubmit}: Props) => {
  const newPasswordRef = React.useRef<HTMLInputElement>(null);
  const classes = useStyles();

  React.useEffect(() => {
    if (newPasswordRef.current !== null) {
      newPasswordRef.current.focus();
    }
  }, []);

  return (
    <Form
      onSubmit={(values) => {
        if (onSubmit) return onSubmit(values);
      }}
      validate={validate}
    >
      {({error, submitting, handleSubmit, submitError}: FormRenderProps) => (
        <form className={classes.form} onSubmit={handleSubmit}>
          <p>Please enter a new password</p>
          {(error || submitError) && !submitting && <div className='error'>{error || submitError}</div>}
          <Grid className={classes.grid} container>
            <Grid item xs={12}>
              <TextField
                name='newPassword' label='New Password' type='password' className={classes.field}
                inputRef={newPasswordRef}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name='confirmNewPassword' label='Confirm New Password' type='password' className={classes.field}
              />
            </Grid>
            <Grid item xs={12}>
              <Button type='submit' className={classes.button} fullWidth disabled={submitting}>Submit</Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: Props) => {
  const {location, navigate, session = '', challengeName = '', challengeParameters = {}} = ownProps;
  const from = location !== undefined ? (location.state || {} as any).from : '';
  const next = from ? from : '/';

  const onSuccess = (response: any) => {
    if (response.token && response.token != '' && navigate) {
      navigate(next);
    }
  };

  return {
    onSubmit: (values: FormValues) => {
      const valuesToSend = {
        challengeName: challengeName,
        challengeResponses: {
          'USERNAME': challengeParameters.USER_ID_FOR_SRP,
          'NEW_PASSWORD': values.newPassword,
        },
        session: session,
      };
      return dispatch(loginAction(valuesToSend, {onSuccess}));
    },
  };
};

export default connect(undefined, mapDispatchToProps)(ResetPasswordForm);
